import { supabase } from "../supabase";

// Insert a saved address, tolerating the duplicate-address unique index (#40).
// A 23505 means this exact address is already on file for the user — return
// the existing row instead of surfacing an error. Returns
// { data, error, duplicate } where duplicate=true when it already existed.
export async function insertAddressDeduped(row) {
  const { data, error } = await supabase.from("addresses").insert(row).select().single();
  if (!error) return { data, error: null, duplicate: false };
  if (error.code === "23505") {
    const { data: existing } = await supabase.from("addresses").select("*")
      .eq("user_id", row.user_id)
      .ilike("street", (row.street || "").trim())
      .eq("zip", (row.zip || "").trim())
      .limit(1);
    return { data: existing?.[0] || null, error: null, duplicate: true };
  }
  return { data: null, error, duplicate: false };
}
